import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ButtonContent from '../ButtonContent';

import { COLORS } from '../../styles/colors';


const FormContent = ({formData, formChange, blockCats, Builder, submitAction, expand, expansionChange, onCancel}) => {
  const PanelHeaderContent = ({step}) => (
    <div style={{display:'flex', width: '100%', justifyContent: 'space-between'}}>
      <div>
        <FontAwesomeIcon icon="chevron-right" style={{marginRight: 5, color: COLORS.orange}}/>
        Step {step}
      </div>
      <div>
        {
          step !== expand ? (
              <FontAwesomeIcon icon="edit" style={{marginRight: 5, color: COLORS.orange}}/>
          ) : null
        }
      </div>
    </div>
  );

  return (
    <div>

      <ExpansionPanel

        expanded={expand === 1}
        onChange={() => expansionChange(1)}>
        <ExpansionPanelSummary className="expand">
          <PanelHeaderContent step={1} />
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Grid container style={{padding:10}}>
            <Grid item xs={6}>
              <TextField
                label={`Block Name`}
                value={formData.name}
                onChange={formChange('name')}
                margin="dense"
                variant="outlined"
                inputProps={{maxLength: 60}}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                select
                label="Category"
                value={formData.categoryId}
                onChange={formChange('categoryId')}
                margin="dense"
                variant="outlined"
              >
                {Object.values(blockCats).map(option => (
                  <MenuItem key={option._id} value={option._id}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <div style={{display: 'flex', width: 180, justifyContent: 'space-between', alignItems: 'center'}}>
                <Button
                  onClick={() => {expansionChange(2)}}
                  variant="contained"
                  color="primary">
                  <ButtonContent
                    text="Save"
                    icon="chevron-right"/>
                </Button>
                <div>or</div>
                <Button onClick={onCancel}>
                  Cancel
                </Button>
              </div>

            </Grid>
          </Grid>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel
        expanded={expand === 2}
        onChange={() => expansionChange(2)}>
        <ExpansionPanelSummary>
          <PanelHeaderContent step={2} />
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          {Builder}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  )
}

export default FormContent



// WEBPACK FOOTER //
// ./src/components/blocks/FormContent.js